import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tenantId: '',
    yearList: [],
    showYear: '',
    showSelectArea: true,
    warehouseName: '全景图',
    totalEmission: 0,
    reduceEmission: 0
  },
  mutations: {
    setTenantId(state, value) {
      state.tenantId = value
    },
    setYearList(state, value) {
      state.yearList = value
    },
    setShowYear(state, value) {
      state.showYear = value
    },
    setShowSelectArea(state, value) {
      state.showSelectArea = value
    },
    setWarehouseName(state, value) {
      state.warehouseName = value
    },
    setTotalEmission(state, value) {
      state.totalEmission = value
    },
    setReduceEmission(state, value) {
      state.reduceEmission = value
    }
  },
  actions: {},
  modules: {}
})